import { ofType } from "redux-observable";
import { mergeMap, debounceTime } from "rxjs/operators";
import { merge, of } from "rxjs";

import { GET_SINGLE_CLIENT_REPORT_ENTRIES } from "../../types";
import { SINGLE_CLIENT_REPORT_ENTRIES_LOG_MESSAGES } from "../../constants/singleClientEntriesReportConstants";
import {
  getSingleClientReportEntriesPending,
  getSingleClientReportEntriesFulfilled,
  getSingleClientReportEntriesRejected,
  setNoEntriesMessage,
} from "../../actions";
import { sendApiRequest, notifyError } from "../../../../actions";
import { singleClientReportFiltersSelector } from "../../selectors";
import generateError from "../../../../utilities/generateError";

const createPayload = (payload) => ({
  method: "post",
  url: "report/getsingleclientspost",
  onSuccess: [
    (response) =>
      response.data.length === 0
        ? setNoEntriesMessage(
            SINGLE_CLIENT_REPORT_ENTRIES_LOG_MESSAGES.NOT_FOUND
          )
        : { type: "" },
    (response) => getSingleClientReportEntriesFulfilled(response),
  ],

  onError: [
    getSingleClientReportEntriesRejected,
    (error) => notifyError(generateError(error)),
  ],
  data: payload,
});
const meta = {
  api: "ajaxApi",
};

const getSingleClientReportEntriesEpic$ = (action$, state$) =>
  action$.pipe(
    ofType(GET_SINGLE_CLIENT_REPORT_ENTRIES.DEFAULT),
    debounceTime(500),
    mergeMap(({ payload }) => {
      const filters = singleClientReportFiltersSelector(state$.value);
      return merge(
        of(getSingleClientReportEntriesPending()),
        of(sendApiRequest(createPayload({ ...payload, ...filters }), meta))
      );
    })
  );

export default getSingleClientReportEntriesEpic$;



// WEBPACK FOOTER //
// ./src/features/reports/epics/single-client/getSingleClientReportEntriesEpic.js